import { StyleSheet } from 'react-native';
import theme from '../../../common/theme';
import { ThemeColors } from '../../../common/theme-colors';

export const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      padding: 16,
      backgroundColor: colors.popup,
    },
    content: {
      flex: 1,
      marginTop: 8,
      rowGap: 16,
    },
    filters: {
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: 10,
    },
    search: {
      flex: 1,
    },
    iconButton: {
      width: 44,
      height: 44,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.radius.s,
      backgroundColor: colors.elevation1,
    },
    // Select
    select: {
      width: 150,
      height: 44,
      paddingHorizontal: 12,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderRadius: theme.radius.s,
      backgroundColor: colors.elevation1,
    },
    selectText: {
      flex: 1,
      fontSize: 13,
      color: colors.text,
      fontFamily: theme.fonts.medium,
    },
    // eslint-disable-next-line react-native/no-color-literals
    selectBackdrop: {
      backgroundColor: 'transparent',
    },
    selectPopover: {
      borderRadius: theme.radius.s,
      backgroundColor: colors.popup,
    },
    selectOptions: {
      minWidth: 150,
      paddingVertical: 4,
    },
    selectOption: {
      paddingVertical: 10,
      paddingHorizontal: 14,
    },
    selectOptionText: {
      fontSize: 13,
      color: colors.text,
      fontFamily: theme.fonts.medium,
    },
    selectOptionSelected: {
      color: colors.neutral,
    },
    // Summary
    summary: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    summaryRow: {
      flexDirection: 'row',
      columnGap: 20,
    },
    summaryItem: {
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: 8,
    },
    squircle: {
      width: 10,
      height: 10,
      borderRadius: 3,
    },
    summaryLabel: {
      fontSize: 13,
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
    },
    summaryCount: {
      color: colors.text,
      fontFamily: theme.fonts.semibold,
    },
    summaryDate: {
      fontSize: 13,
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    // Table
    table: {
      flex: 1,
      borderWidth: 1,
      borderRadius: theme.radius.s,
      borderColor: colors.border,
    },
    tableHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 10,
      paddingHorizontal: 16,
      paddingLeft: 48,
      backgroundColor: colors.elevation1,
    },
    headerText: {
      fontSize: 12,
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
      textTransform: 'uppercase',
    },
    emptyText: {
      paddingVertical: 40,
      textAlign: 'center',
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
    },
    tableBody: {
      flex: 1,
    },
    tableRow: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingVertical: 12,
      paddingHorizontal: 16,
      borderTopWidth: 1,
      borderTopColor: colors.border,
    },
    rowError: {
      backgroundColor: colors.negativeXL,
    },
    levelIcon: {
      width: 32,
    },
    rowText: {
      fontSize: 13,
      color: colors.text,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    colTime: {
      width: 170,
    },
    colType: {
      width: 130,
    },
    colDescription: {
      flex: 1,
    },
    pagination: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 10,
      paddingHorizontal: 16,
      borderTopWidth: 1,
      borderTopColor: colors.border,
    },
    paginationText: {
      fontSize: 12,
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
      fontVariant: ['tabular-nums'],
    },
    paginationButtons: {
      flexDirection: 'row',
      columnGap: 8,
    },
    pageButton: {
      width: 32,
      height: 32,
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.radius.s,
      backgroundColor: colors.elevation1,
    },
    disabled: {
      opacity: 0.4,
    },
    // Detail
    detail: {
      flex: 1,
      borderWidth: 1,
      borderRadius: theme.radius.s,
      borderColor: colors.border,
    },
    detailHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 12,
      paddingHorizontal: 16,
      backgroundColor: colors.elevation1,
    },
    detailTitle: {
      fontSize: 14,
      color: colors.text,
      fontFamily: theme.fonts.semibold,
    },
    detailScroll: {
      flex: 1,
      padding: 16,
    },
    detailItem: {
      marginBottom: 14,
      rowGap: 4,
    },
    detailLabel: {
      fontSize: 12,
      color: colors.textLight,
      fontFamily: theme.fonts.medium,
      textTransform: 'uppercase',
    },
    detailValue: {
      fontSize: 13,
      color: colors.text,
      fontFamily: theme.fonts.medium,
    },
    jsonContainer: {
      padding: 10,
      borderRadius: theme.radius.s,
      backgroundColor: colors.elevation1,
    },
    jsonContent: {
      fontSize: 12,
      color: colors.textBody,
      fontFamily: theme.fonts.regular,
    },
  });
